import styled from 'styled-components';
import { ModalCarOptionDetailStyled } from '../../ModalCarOptionDetailStyled';
import { rem } from 'polished';

export const ModalCarOptionDetailStyledOV = styled(ModalCarOptionDetailStyled)`
    font-size: ${rem(16)};

    .option-detail {
        &__category {
            color: ${({ theme }) => theme.colors.black2};
        }

        &__title {
            color: ${({ theme }) => theme.colors.black2};
            font-size: ${rem(30)};
            line-height: ${rem(38)};
        }

        &__description {
            color: ${({ theme }) => theme.colors.black2};
            line-height: ${rem(20)};
        }
    }

    .tires-detail {
        background: ${({ theme }) => theme.colors.grey10};

        &__title {
            text-transform: uppercase;
        }

        &__description {
            border-color: ${({ theme }) => theme.colors.grey11};
            font-size: ${({ theme }) => theme.fontSizes.h5};
            line-height: ${rem(20)};
        }

        &__image {
            border-color: ${({ theme }) => theme.colors.grey11};
        }

        &__link {
            color: ${({ theme }) => theme.colors.black1};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};

            svg {
                width: ${rem(10)};
                height: ${rem(10)};
                margin-left: ${rem(5)};
                margin-bottom: ${rem(1)};

                path {
                    fill: ${({ theme }) => theme.colors.black1};
                }
            }

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.black1};
                text-decoration: underline;
            }
        }
    }
`;
